module.exports = __webpack_public_path__ + "img/anewitem-soccer.527b28ff.svg";